<div class="dialog-header">
  <div class="section-header">
    <span class="section-icon"
      [class.section-icon--danger]="content.confirm"
      [class.section-icon--blue]="!content.confirm">
      <mat-icon>{{ content.confirm ? 'warning' : 'info' }}</mat-icon>
    </span>
    <h2 class="section-title">{{ content.title }}</h2>
  </div>
</div>

<mat-dialog-content>
  <p class="dialog-message">{{ content.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (content.confirm) {
    <button mat-button [mat-dialog-close]="false">{{ content.cancelLabel || 'Cancel' }}</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">{{ content.confirmLabel || 'Confirm' }}</button>
  } @else {
    <button mat-button mat-dialog-close>{{ content.closeLabel || 'Close' }}</button>
    @if (content.link) {
      <button mat-button mat-dialog-close [routerLink]="content.link">Go Back</button>
    }
  }
</mat-dialog-actions>
